import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { MAP_KEY } from '../../google-license'; // Import your Google Maps API key from a separate file

@Injectable({
  providedIn: 'root'
})

export class GoogleMapsService {

  private googleInstance: any = null;

  private googleLoaded$ = new ReplaySubject<number>(1);
  private scriptAdded = false;

  constructor() {
    this.loadGoogleMapsAPI(MAP_KEY).subscribe({
      next: (google) => {
        console.log(google)
        this.googleInst = google;
      },
      error: (err) => {
        console.error('Google Maps failed to load', err);
      }
    });
  }

  private set googleInst(value: any) {
    this.googleInstance = value;
  }

  public get googleInst(): any {
    return this.googleInstance;
  }

  loadGoogleMapsAPI(apiKey: string): Observable<number> {
    if (!this.scriptAdded) {
      this.scriptAdded = true;

      const script = document.createElement('script');
      script.id = 'googleMapsScript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&callback=initMapAPI`;
     // script.async = true;
     // script.defer = true;

      (window as any).initMapAPI = () => {
        this.googleLoaded$.next((window as any).google);
        this.googleLoaded$.complete();
      };

      script.onerror = (err) => {
        this.googleLoaded$.error(err);
      };

      document.head.appendChild(script);
    }

    return this.googleLoaded$.asObservable();
  }




  calculateOptimalRoute(coordinates: any[]): Promise<{ link: string, optimizedCoordinates: any[] }> {
    return new Promise((resolve, reject) => {
      const directionsService = new this.googleInst.maps.DirectionsService();

      const origin = coordinates[0];
      const destination = coordinates[coordinates.length - 1];
      console.log(coordinates, 'coordinates');
      const waypoints = coordinates.slice(1, -1).map(coord => ({
        location: new this.googleInst.maps.LatLng(coord.lat, coord.lng),
        stopover: true
      }));

      const request = {
        origin: new this.googleInst.maps.LatLng(origin.lat, origin.lng),  // Starting point
        destination: new this.googleInst.maps.LatLng(destination.lat, destination.lng),  // Ending point
        waypoints: waypoints,  // Waypoints to pass through
        travelMode: this.googleInst.maps.TravelMode.DRIVING,  // Driving mode (you can change this to WALKING, BICYCLING, etc.)
        optimizeWaypoints: true  // Request for the optimal route
      };

      directionsService.route(request, (result: any, status: any) => {
        if (status === this.googleInst.maps.DirectionsStatus.OK) {
          const optimizedWaypoints = result.routes[0].waypoint_order;
          const optimizedCoordinates = [origin, ...optimizedWaypoints.map(index => coordinates[index + 1]), destination];
          console.log(optimizedCoordinates, 'optimized coordinates');
          // Construct the Google Maps link with the optimized waypoints
          const link = this.generateGoogleMapsLink(optimizedCoordinates);
          console.log(link);
          resolve({ link: link, optimizedCoordinates: optimizedCoordinates });
        } else {
          console.error('Directions request failed due to ' + status);
          reject('Directions request failed due to ' + status);
        }
      });
    });
  }

  generateGoogleMapsLink(coordinates: { lat: number, lng: number }[]): string {
    const origin = coordinates[0];
    const destination = coordinates[coordinates.length - 1];
    const waypoints = coordinates.slice(1, -1).map(coord => `${coord.lat},${coord.lng}`).join('|');

    return `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&waypoints=${waypoints}`;
  }
}